<template>
  <LoginWrapper plateform-type="dd">
    <LoginQRCode
      :user-name="userName"
      :detail="visitorRcord"
      @refreshQR="refreshQR"
    />
  </LoginWrapper>
</template>

<script>
import LoginWrapper from "./components/loginWrapper.vue"
import LoginQRCode from "./components/loginQRCode.vue"
import { ref, computed } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex"
export default {
  components: {
    LoginWrapper,
    LoginQRCode,
  },
  setup() {
    const store = useStore()
    const router = useRouter()

    const navBarThemeVars = ref({
      navBarTextColor: "#fff",
      navBarBackgroundColor: "transparent",
    })

    const flagFirstInfo = computed({
      get: () => store.state.flagFirstInfo,
      set: (payload) => {
        store.commit("setFlagFirstInfo", payload)
      },
    })
    const userName = computed({
      get: () => store.state.userName,
      set: (payload) => {
        store.commit("setUserName", payload)
      },
    })
    const visitorRcord = computed({
      get: () => store.state.visitor.visitorRcord,
      set: (payload) => store.commit("visitor/setVisitorRcord", payload),
    })

    // const store = useStore()
    // const route = useRoute()
    // const router = useRouter()

    // const flagFirstInfo = computed({
    //   get: () => store.state.flagFirstInfo,
    //   set: (payload) => {
    //     store.commit("setFlagFirstInfo", payload)
    //   },
    // })

    // const plateformTypeCop = computed(() => store.state.plateformType)
    // const userTypeCop = computed(() => store.state.userType)
    // const userNameCop = computed(() => store.state.userName)
    // const schoolCodeCop = computed(() => store.state.schoolCode)

    // const visitorRcord = computed(() => store.state.visitor.visitorRcord)

    // 初始换配置参数
    // let { schoolCode, plateformType, userType, userName, token } = route.query
    // const initRouteParams = () => {
    //   store.commit("setToken", token)
    //   store.commit("setSchoolCode", schoolCode)
    //   store.commit("setPlateformType", plateformType)
    //   store.commit("setUserType", userType)
    //   store.commit("setUserName", userName || localStorage.getItem("userName"))
    // }
    // initRouteParams()

    // const navBarThemeVars = {
    //   navBarTextColor: "#fff",
    //   navBarBackgroundColor: "transparent",
    // }

    const parentAppInfo = (params) =>
      store.dispatch("visitor/parentAppInfo", params)

    const refreshQR = async () => {
      let params = {
        id: "",
      }
      let r = await parentAppInfo(params)
      if (r.success && r.data) {
        visitorRcord.value = r.data
      } else {
        if (flagFirstInfo.value && isHistory.value) {
          flagFirstInfo.value = false
          router.push({
            path: "/visitorRecord",
          })
        }
      }
    }

    const isHistory = ref(false)
    const parentCheckHistory = (params) =>
      store.dispatch("visitor/parentCheckHistory", params)
    const checkHistory = async () => {
      let r = await parentCheckHistory()
      let { success, data } = r || {}
      if (success && data) {
        refreshQR()
        isHistory.value = true
      } else {
        if (flagFirstInfo.value) {
          flagFirstInfo.value = false
          router.push({
            path: "/visitorApply",
          })
        }
      }
    }
    checkHistory()
    return {
      navBarThemeVars,
      visitorRcord,
      userName,
      refreshQR,
    }
  },
}
</script>

<style lang="less" scoped>
.login-wrapper {
  .login-content {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
